import React, { useEffect, useState, useNavigate } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
} from "@azure/msal-react";
// AuthenticatedTemplate → แสดง UI เฉพาะเมื่อ login แล้ว
// UnauthenticatedTemplate → แสดง UI เฉพาะเมื่อยังไม่ login
// useIsAuthenticated → hook คืนค่า true/false ว่า login อยู่ไหม
import { SignInButton } from "../components/SignInButton";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
export function Login() {
  const isAuthenticated = useIsAuthenticated();
  const [isRedirecting, setIsRedirecting] = useState(false);
  // useEffect(() => {
  //   if (isAuthenticated) {
      // const userId = localStorage.getItem('USER_ID');
      // const isValidUser = userId && userId !== "undefined" && userId !== "null";
      // if(userId !== "undefined" ){
      //   console.log("!undefined")
      // }
      // if(userId !== "null" ){
      //   console.log("!null")
      // }
      // const userId = localStorage.getItem("USER_ID");
      // if (userId && userId !== "undefined" && userId !== "null") {
      //   // มี USER_ID จริง
      //   console.log("มี USER_ID จริง");
      // } else {
      //   console.log("ไม่มี USER_ID");
      // }
      // console.log("... " + userId);
      //if (isValidUser) {
      // if (localStorage.getItem('USER_ID')!== "undefined") {
      //   setIsRedirecting(true);
      //   localStorage.setItem('LOGIN',"YES");
      //   window.location = "/s-crm/AuthenProfile";// redirect
      // } else {
      //   localStorage.setItem('LOGIN',"NO");
      //   console.warn("No valid USER_ID found, redirecting to logout");
      //   window.location = "./logout"; // บังคับ logout
      // }
  //   } else {
  //     localStorage.setItem("LOGIN", "NO");
  //   }
  // }, [isAuthenticated]);
  // ❌ โค้ดปัจจุบัน: เช็คแบบนี้มีปัญหา ❌
  //localStorage.getItem('USER_ID') !== "undefined"
  // ปัญหา:
  // - ถ้าไม่มี key เลย → getItem คืน null  → null !== "undefined" = TRUE  ← ผ่านทั้งที่ไม่ควร!
  // - ถ้าค่าเป็น string "undefined" → FALSE ← ถูก
  // - ถ้าค่าเป็น undefined จริงๆ → undefined !== "undefined" = TRUE ← ผ่านทั้งที่ไม่ควร!

  useEffect(() => {
    if (isAuthenticated) {
      if (localStorage.getItem('USER_ID')!== "undefined") {
        localStorage.setItem('LOGIN',"YES");
        window.location = "/s-crm/AuthenProfile";// redirect
      }else{
        localStorage.setItem('LOGIN',"NO");
        console.log("no cookies")
        window.location = "./logout"; // บังคับ logout
      }
    } else {
      localStorage.setItem('LOGIN',"NO");
      // go back to the public landing page where the user can try to login again
    }
  }, [isAuthenticated]);
  if (isRedirecting) {
    return <div>กำลังเข้าสู่ระบบ...</div>;
  }
  //const classes = useStyles();
  return (
    <>
      <AuthenticatedTemplate>
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#FFFFFF",
          }}
        >
          <h5 className="card-title">Welcome</h5>
        </div>
      </AuthenticatedTemplate>

      {/* เห็นเฉพาะตอนยังไม่ login */}
      <UnauthenticatedTemplate>
        <div>
          <div className="LoginBox">
            <div>
              <h2>Log in to S-CRM</h2>
              <br />
            </div>
            <SignInButton /> {/* ปุ่มให้กด login ผ่าน MS365 */}
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}
